import { TudigoLogoRebrand } from "../rebrand/logo/tudigo-logo-rebrand";

export function TudigoFullPageLoading() {
  return (
    <div className="fixed flex h-screen w-screen items-center justify-center">
      <TudigoLogoRebrand className="animate-pulse" />
    </div>
  );
}
